import { Dialog } from "primereact/dialog";
import { JVInput } from "../../shared/JVInput";
import { Button } from "primereact/button";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { Fetch } from "../../shared/Fetch";
import { useEffect, useState } from "react";
import { IBlackListStatusMast } from "./Table";

interface IProps {
    singleData: IBlackListStatusMast,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

const schema = yup.object({
    blacklist_Status: yup.string().required("Status Name is required"),
});

export const Form = (props: IProps) => {
    const [saveDis, setSaveDis] = useState(false);

    const { control, handleSubmit, watch, formState: { errors }, reset } = useForm<IBlackListStatusMast>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    const onSubmit = (data: any) => {
        setSaveDis(true);
        saveToDB(data);
    }

    const saveToDB = async (data: any) => {
        const method = props.singleData.blacklist_Status != "" ? "PUT" : "POST";
        const message = props.singleData.blacklist_Status != "" ? "Updated Successfully" : "Added Successfully";

        const response = await Fetch("BlackList_Status_Mast", method, data, null, props.toast);
        if (response) {
            props.hideDialog();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.setReload(!props.reload);
            setSaveDis(false);
        } else {
            setSaveDis(false);
        }
    }

    const onHide = () => {
        props.hideDialog();
    }

    useEffect(() => {
        reset(props.singleData);
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit BlackList Status" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput required label="Status Name:" control={control} name="blacklist_Status" error={errors.blacklist_Status?.message} />
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="SAVE" type="submit"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200		"></Button>
                </div>
            </form>
        </Dialog>
    );
}